import { useCallback, useContext, useState } from "react";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddNotification = () => {
  const { t } = useLocale();
  const { save } = useService("Data", "notification");
  const { setTitle } = useService("Meta");
  const { generateUID, showAlert } = useService("Misc");
  const { navigateTo } = useContext(NavigatorContext);
  const { isValidJson } = useService("Validation");
  const [body, setbody] = useState<string>("");
  const [jsonData, setjsonData] = useState<string>("");
  const [image, setimage] = useState<string>("[]");
  const [title, settitle] = useState<string>("");

  setTitle(t("addNotification"), "admin");

  const addNotification = useCallback(
    async (e) => {
      e.preventDefault();
      let error = false,
        errorMsg = "",
        notificationObject = {
          title,
          body: body,
          jsonData: jsonData,
          timing: new Date().getTime(),
          image: typeof image === "undefined" ? "[]" : image,
          uid: generateUID(),
        };
      if (title === "") {
        errorMsg = t("errorMsg.required.notificationTitle");
        error = true;
      } else if (body === "") {
        errorMsg = t("errorMsg.required.notificationBody");
        error = true;
      } else if (jsonData !== "") {
        if (!isValidJson(jsonData)) {
          errorMsg = t("errorMsg.validate.notificationJson");
          error = true;
        }
      }
      if (!error) {
        const result = await save(notificationObject);
        if (result.status) {
          showAlert({ type: "success", msg: t("success.addNotification") });
          navigateTo({ route: "/admin/notification/list" });
        } else
          showAlert({ type: "error", msg: t("errorMsg.fail.addNotification") });
      } else showAlert({ type: "error", msg: errorMsg });
    },
    [
      body,
      generateUID,
      image,
      isValidJson,
      jsonData,
      navigateTo,
      save,
      showAlert,
      t,
      title,
    ]
  );
  return {
    pageTitle: t("addNotification"),
    addNotification,
    title,
    settitle,
    body,
    setbody,
    jsonData,
    setjsonData,
    image,
    setimage,
  };
};
